import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
// Import Components
import { BonusModal } from 'components';

const BonusActionsModals = (props) => {
    const { isInfoModalOpenedState, onCloseModalHandler, modalsStateSetDict, openedModalData } = props;

    const { Id } = openedModalData;

    return (
        !isEmpty(openedModalData) && (
            <>
                {isInfoModalOpenedState && (
                    <BonusModal
                        bonusId={Id}
                        handleClose={() => onCloseModalHandler(modalsStateSetDict.infoBonus.key)}
                        isVisible={isInfoModalOpenedState}
                    />
                )}
            </>
        )
    );
};

BonusActionsModals.propTypes = {
    isInfoModalOpenedState: PropTypes.bool.isRequired,
    onCloseModalHandler: PropTypes.func.isRequired,
    modalsStateSetDict: PropTypes.object.isRequired,
    openedModalData: PropTypes.object.isRequired,
};

export default memo(BonusActionsModals);
